import get from 'lodash/get';
import each from 'lodash/each';
import isNil from 'lodash/isNil';
import isArray from 'lodash/isArray';
import includes from 'lodash/includes';

import loglevel from 'loglevel';

import { sendRequest } from 'zoomforth_zfutils/xhr_tools.js';

import { showErrorNotification } from 'zoomforth_codesbane_editor/action_creators/misc.js';
import { CheckCircleIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';
import {
  success as showSuccessNotification
} from 'zoomforth_app_basics/action_creators/notifications.js';

import {
  CLIPBOARD_ITEM_TYPE_TILE,
  CLIPBOARD_ITEM_TYPE_SECTION,
  CLIPBOARD_ITEM_TYPE_SUBPAGE
} from 'zoomforth_codesbane_editor/lib/user_clipboard/const.js';

import {
  SET_CAN_PASTE_TILE_DATA,
  SET_CAN_PASTE_SECTION_DATA,
  SET_CAN_PASTE_SUBPAGE_DATA,
  SET_CLIPBOARD_ITEMS_CACHE,
  REMOVE_CLIPBOARD_ITEMS_FROM_CACHE_BY_ID
} from 'zoomforth_codesbane_editor/action_types.js';


const serializeClipboardItemsIDs = function(clipboardItems) {
  if (isNil(clipboardItems) || !isArray(clipboardItems)) {
    throw new Error(`serializeClipboardItemsIDs expects clipboard items to be typeof Array; Found: ${typeof clipboardTtems} `)
  }

  var params = new URLSearchParams();

  each(clipboardItems, item => params.append('id', item.id));

  return params.toString();
};


export const setCanPasteTileData = (canPaste)=> {
  return { type: SET_CAN_PASTE_TILE_DATA, canPaste };
};

export const setCanPasteSectionData = (canPaste)=> {
  return { type: SET_CAN_PASTE_SECTION_DATA, canPaste };
};

export const setCanPasteSubpageData = (canPaste)=> {
  return { type: SET_CAN_PASTE_SUBPAGE_DATA, canPaste };
};

export const setIsClipboardModalOpen = (isOpen, type) => {
  return { isOpen, type };
};

export const setClipboardItemsCache = (clipboardItems) => {
  return { clipboardItems, type: SET_CLIPBOARD_ITEMS_CACHE }
}

export const removeClipboardItemsFromItemCacheById = (deletedClipboardItemsIds) => {
  return { deletedClipboardItemsIds, type: REMOVE_CLIPBOARD_ITEMS_FROM_CACHE_BY_ID }
}

export const refreshAvailableClipboards = ()=>
  (dispatch)=> {
    sendRequest({
      url: '/api/user_clipboard',
      method: 'GET',
      noCache: true,
      onSuccess: (availableClipboards) => {
        each(availableClipboards, ({ type }) => {
          if (type === CLIPBOARD_ITEM_TYPE_TILE)
            dispatch(setCanPasteTileData(true));
          else if (type === CLIPBOARD_ITEM_TYPE_SECTION)
            dispatch(setCanPasteSectionData(true));
          else if (type === CLIPBOARD_ITEM_TYPE_SUBPAGE)
            dispatch(setCanPasteSubpageData(true));
        });

        dispatch(setClipboardItemsCache(availableClipboards));
      },
      onError: ()=> {
        loglevel.warn('Could not retrieve clipboard data for user');
      }
    });
  };

export const fetchClipboardDataForType = (clipboardType, onSuccess)=>
  (dispatch)=> {
    sendRequest({
      url: `/api/user_clipboard/${clipboardType}`,
      method: 'GET',
      noCache: true,
      onSuccess: onSuccess,
      onError: ()=> {
        loglevel.error('Could not get clipboard data for user');
        dispatch(showErrorNotification(
          'Clipboard Error',
          `Could not retrieve ${clipboardType} data from your clipboard.`
        ));
      }
    });
  };

export const setClipboardData = (clipboardType, clipboardData)=>
  (dispatch, getState)=> {
    const site_id = get(getState(), 'pageMeta.id');

    sendRequest({
      url: `/api/user_clipboard/${clipboardType}`,
      method: 'POST',
      params: { clipboard_data: clipboardData, site_id: site_id },
      onSuccess: (response) => {
        if (response) {
          dispatch(removeClipboardItemsFromItemCacheById(response));
        }
      },
      onError: ({ status, response }) => {
        const responseJson = JSON.parse(response);
        const errorMessage = get(responseJson, 'error.message');

        loglevel.error('Could not save clipboard data for user');
        dispatch(showErrorNotification(
          'Clipboard Error',
          errorMessage ? errorMessage
          :
          `Could not save ${clipboardType} data to your clipboard.`
        ));
      }
    });
  };

export const openClipboardModal = (clipboardType)=>
  (dispatch) => {
    dispatch(setIsClipboardModalOpen(true, clipboardType));
  };

export const deleteMultipleClipboardItems = (clipboardItemsIds) =>
  (dispatch) => {
    sendRequest({
      url: `/api/user_clipboards`,
      method: 'DELETE',
      params: { clipboard_ids: clipboardItemsIds },
      noCache: true,
      onSuccess: (response) => {
        dispatch(showSuccessNotification({
          message: `Deleted ${clipboardItemsIds.length} clipboard item${clipboardItemsIds.length === 1 ? '': 's'} from clipboard`
        }));
        dispatch(removeClipboardItemsFromItemCacheById(response));
      },
      onError: () => {
        loglevel.error('Could not delete clipboard data');
        dispatch(showErrorNotification(
          'Clipboard Error',
          `Could not delete clipboard data.`
        ));
      }
    });
  };